import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import InputInline from "../components/InputInline";
import { pingMailchimp } from "../api/AppLinkApi";

const MailchimpSetting = ({ appInfo, onChange, connectionStatus }) => {
  const { t } = useTranslation();
  const { accessToken = {} } = appInfo;
  const [errorMessage, setErrorMessage] = useState("");
  const [pingMessage, setPingMessage] = useState("");

  useEffect(() => {
    if (accessToken.apiKey) {
      pingMailchimp()
        .then((data) => {
          setErrorMessage("");
          setPingMessage(data.health_status);
        })
        .catch(() => {
          setErrorMessage(t("Api is invalid"));
          setPingMessage("");
        });
    } else {
      setErrorMessage(t("API Key is required!"));
      setPingMessage("");
    }
  }, [appInfo]); // eslint-disable-line react-hooks/exhaustive-deps

  const renderError = () => {
    if (errorMessage != "") {
      return <div className={"text-red-600"}>{t(errorMessage)}</div>;
    }
  };

  const renderPingMessage = () => {
    if (pingMessage != "") {
      return (
        <div className={"text-green-500"}>
          {t("Ping")}: {pingMessage}
        </div>
      );
    }
  };

  return (
    <>
      <div className="grid grid-cols-12 gap-4 mb-4">
        <div className="col-span-12 lg:col-span-3">
          <div className={"space-y-2 align-middle"}>
            <div className={"w-40"}>{t("Status")}</div>
            <div className={"text-sm text-gray-400"}>{t("Connection to Mailchimp")}</div>
          </div>
        </div>
        <div className="col-span-12 lg:col-span-9">
          <div className="flex items-center gap-x-3">
            {connectionStatus()}
            {renderError()}
            {renderPingMessage()}
          </div>
        </div>
      </div>
      <div className="grid grid-cols-12 gap-4 mb-4">
        <div className="col-span-12 lg:col-span-3">
          <div className={"space-y-2 align-middle"}>
            <div className={"w-40"}>{t("API Key")}</div>
            <div className={"text-sm text-gray-400"}>{t("Used to make API calls")}</div>
          </div>
        </div>
        <div className="col-span-12 lg:col-span-9">
          <InputInline
            type={"password"}
            value={accessToken.apiKey}
            border={true}
            onFinish={(value) => {
              onChange({
                app: appInfo.app,
                fieldId: "apiKey",
                fieldValue: value,
              });
            }}
          />
        </div>
      </div>
      <div className="grid grid-cols-12 gap-4 mb-4">
        <div className="col-span-12 lg:col-span-3">
          <div className={"space-y-2 align-middle"}>
            <div className={"w-40"}>{t("Server prefix")}</div>
            <div className={"text-sm text-gray-400"}>{t("Look for your prefix in URL")}</div>
          </div>
        </div>
        <div className="col-span-12 lg:col-span-9">
          <InputInline
            value={accessToken.dc}
            border={true}
            onFinish={(value) => {
              onChange({
                app: appInfo.app,
                fieldId: "dc",
                fieldValue: value,
              });
            }}
          />
          <div className={"text-sm text-gray-400"}>
            {t("You’ll see something like https://us19.admin.mailchimp.com/ → the ")}
            <b>us19</b>
            {t(" part is server prefix")}
          </div>
        </div>
      </div>
    </>
  );
};

export default MailchimpSetting;
